import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=40ccf674&scoped=true"
import script from "./GanttChart.vue?vue&type=script&lang=js"
export * from "./GanttChart.vue?vue&type=script&lang=js"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=40ccf674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccf674",
  null
  
)

export default component.exports